import React from "react";
import CreateStockOpname from "../../../components/screen/inventory/StockOpname/CreateStockOpname";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";

const CreateStockOpnamePage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={"Add Stock Opname " + (isWarehouse ? "Central Warehouse" : "")}
        mainComponent={<CreateStockOpname isWarehouse={isWarehouse} />}
        pageRole={23}
      />
    </div>
  );
};

export default HOC(CreateStockOpnamePage);
